export default angular.module("ticketco/common")
  .filter("percentage", function ($filter) {
    return function (input, maybeDecimals) {
      var decimals = angular.isDefined(maybeDecimals) ? maybeDecimals : 2;
      if (typeof input === "undefined") return undefined;
      return $filter("number")(input, decimals) + "%";
    };
  });
